var beamCanvas;
var resultsViewCanvas;
var crossSectionCanvas;
var canvasRect = [900,300];
var beam_t = 25;
var beam_y = canvasRect[1] - 125;
var brace_size = 5;

var g_results;
var numericalCaseSet = null;
var gSuppressRedraw = false;
var debug = false;

// redraw canvas when resize is complete
var rtime = new Date(1, 1, 2000, 12, 0, 0);
var timeout = false;
var delta = 100;
$(window).resize(function() {
    rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeend, delta);
    }
});

function resizeend() {
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;
        resizeCanvasArea();
    }
}

function resizeCanvasArea() {
    var canvasW = Math.min($('#canvas-pane').width(), 900);
    var canvasH = Math.min(parseFloat(canvasRect[0]) * parseFloat(canvasRect[1]) / canvasW, 300);
    canvasRect = [canvasW, canvasH];
    beamCanvas.rect(0,0, canvasRect[0], canvasRect[1]);
    resultsViewCanvas.rect(0,0, canvasRect[0], canvasRect[1]);
    RedrawCanvas();
}

function RedrawCanvas() {
    if(gSuppressRedraw === false) {
        beamCanvas.clear();
        resultsViewCanvas.clear();
        drawBeamModel(activeProject);
        drawResultsView(activeProject);
    }
}

function initializeDrawingCanvas() {
    beamCanvas = Raphael("canvas-pane", canvasRect[0], canvasRect[1] );
    beamCanvas.rect(0,0,canvasRect[0], canvasRect[1]);

    resultsViewCanvas = Raphael("results-canvas-pane", canvasRect[0], canvasRect[1] );
    resultsViewCanvas.rect(0,0,canvasRect[0], canvasRect[1]);

    $('#bracing-form').bind("ws_redraw", function() {
        RedrawCanvas();
    });
    $('#material-form').bind("ws_redraw", function() {
        RedrawCanvas();
    });

    resetBeamModelAndSetActiveProject();

    RedrawCanvas();
}

var span_dom_elements = [];

function drawBeamModel(project) {
    //loop over spans and draw them...
    //need to scale the beam spans to fit the canvas
    var beam = project.beam;
    var design = project.design;
    var shape = project.shape;

    if( beam.nodes.length <= 1 ){
        return;
    }

    //*******************
    // Cross section
    //*******************
    setCrossSectionBeamRotationButton();
    if(project.isCustom) {
        shape = project.customShape;
    }
    drawCrossSection(shape, beam.crossSectionRotation, beamCanvas);

    //*******************
    // Beam Span
    //*******************
    var totalLength = beam.TotalLength();
    var x_scale = canvasRect[0]/(1.1*totalLength);
    var x_start = 0.05*totalLength*x_scale;
    var span_dom_elements = [];

    var spanAttr = steel_span_attr;
    if(project.isCustom || project.isAluminum) {
        span_attr = custom_shape_span_attr;
    } else if(project.isNorthAmericanSteel || project.isEuropeanSteel || project.isASTMSteel) {
        span_attr = steel_span_attr;
    } else if(project.isWood || project.isEngineeredLumber) {
        span_attr = wood_span_attr;
    }

    for( var i = 0; i < beam.nodes.length-1; i++ ) {
        var x1 = x_start + x_scale*beam.nodes[i].x;
        var x2 = x_start + x_scale*beam.nodes[i+1].x;
        var dist = beam.nodes[i+1].x-beam.nodes[i].x;
        span_dom_elements.push(drawBeamSpan(
            x1, x2, beam_y, beam_y+beam_t, span_attr, i+1, showLengthWithUnits(dist),
            activeProject.shape, beamCanvas, "wsSpan_" + i ));
    }
    //now make hover over one dom element select them all...
    for( var i = 0; i < span_dom_elements.length; i++ ) {
        var self = span_dom_elements[i][0];
        self.node.onmouseover = function(){
                this.style.cursor = 'pointer';
                for( var j = 0; j < span_dom_elements.length; j++ ){
                    span_dom_elements[j][0].attr(selected_attr);
                }
            }
        self.node.onmouseout = function(){
                for( var j = 0; j < span_dom_elements.length; j++ ){
                    span_dom_elements[j][0].attr(span_attr);
                    //setSelectableTrigger(self, neighbor, span_attr, selected_attr, "");
                }
            }
        var self2 = span_dom_elements[i][1];
        self2.node.onmouseover = function(){
                this.style.cursor = 'pointer';
                for( var j = 0; j < span_dom_elements.length; j++ ){
                    span_dom_elements[j][0].attr(selected_attr);
                }
            }
        self2.node.onmouseout = function(){
                for( var j = 0; j < span_dom_elements.length; j++ ){
                    span_dom_elements[j][0].attr(span_attr);
                }
            }
    }

    //*******************
    // Supports
    //*******************
    for( var i = 0; i < beam.nodes.length; i++ ) {
        var x1 = x_start + x_scale*beam.nodes[i].x;
        var support = beam.nodes[i].support;
        drawSupport( support, x1, beam_y+beam_t, beam_t, beamCanvas, i);
    }

    //*******************
    // Bracing
    //*******************
    if( design.bracingType === "custom" || design.bracingType === "equal" ) {
        var brace = 0;
        var beamLength = beam.TotalLength();
        for( var i = 0; i < design.customBraces.length; i++ ) {
            brace = design.customBraces[i].x;
            if( brace <= beamLength ) {
                brace *= x_scale;
                brace += x_start;
                drawBrace( brace, beam_y, brace_size, beamCanvas );
                drawBrace( brace, beam_y+beam_t, brace_size, beamCanvas );
            }
        }
    }

    //*******************
    // Distributed Loads
    //*******************
    //arrange distributed loads
    var load_y = []
    for(var i = 0; i < beam.distLoads.length; i++) {
        var y = beam_y;
        for(var j = 0; j < i; j++) {
            if(beam.distLoads[j].Overlaps(beam.distLoads[i])) y -= dist_load_arrow_shaft;
        }
        load_y.push(y);
    }

    var labels = [];
    //now draw them so that labels don't get covered up
    for( var i = beam.distLoads.length-1; i >= 0; i-- ) {
        var x1 = x_start + x_scale * beam.distLoads[i].x1;
        var x2 = x_start + x_scale * beam.distLoads[i].x2;
        var l = beam.distLoads[i].Label("k/ft");
        for( var j = 0; j < i; j++ ) {
            if( beam.distLoads[j].Overlaps(
                beam.distLoads[i])) y -= dist_load_arrow_shaft;
        }
        var y = beam_y;
        if(load_y[i]) y = load_y[i];
        if(beam.distLoads[i].isLinear){
            labels.push(drawLinearLoad(
                beam.distLoads[i].D, beam.distLoads[i].D2, x1, x2, y, y, l, beamCanvas, i));
        }else{
            labels.push(
                drawDistributedLoad(beam.distLoads[i].direction(), x1, x2, y, l, beamCanvas, i));
        }
    }
    //*******************
    // Point Loads
    //*******************
    for(var i = 0; i < beam.pointLoads.length; i++) {
        var x1 = x_start + x_scale * beam.pointLoads[i].x;
        var l = beam.pointLoads[i].createLabel();
        if( beam.pointLoads[i].isMoment ) {
            labels.push(drawMomentLoad(x1, beam_y, beam_t, l, beamCanvas, i));
        } else {
            labels.push(drawPointLoad(x1, beam_y, l, beamCanvas, i));
        }
    }

    labels = labels.flat()
    for(var i = 0; i < labels.length; i++) {
        labels[i].toFront();
    }
}

function ClearFlexureDesignResults() {
    $("#beam-design-panel").html("");
    $("#beam-graph-panel").html("");
    $("#beam-numerical-results-panel").html("");
}

function highlightAndFadeTheDrawing() {
    var bending_unity = g_results["bending_checks"]["controlling_unity"];
    var shear_unity = g_results["shear_checks"]["controlling_unity"];
    var deflection_unity = g_results["deflection_checks"]["controlling_unity"];
    var str = '';
    if( bending_unity < 1.0 && shear_unity < 1.0 && deflection_unity < 1.0 ){
        $('#model-panel').addClass('panel-success');
        $('#model-panel').removeClass('panel-danger');
    } else {
        $('#model-panel').removeClass('panel-success');
        $('#model-panel').addClass('panel-danger');
    }
}
